<template>
  <div class="change_password">
      <div class="content">
          <el-form
          :model="ruleForm" :rules="rules"
          label-width="100px"
          label-position="left"
          ref="ruleForm"
          @validate="validate"
          >
              <el-form-item label="手机号：" prop="mobile">
                  <el-input class="input-width" v-model="ruleForm.mobileMask" disabled></el-input>
              </el-form-item>
              <el-form-item label="验证码：" prop="mobileCode">
                  <el-input
                  class="input-width"
                  placeholder="请输入验证码"
                  v-model="ruleForm.mobileCode"></el-input>
                  <el-button @click="getCode" v-cloak class="getCode">{{captchaText}}</el-button>
              </el-form-item>
              <el-form-item label="新密码：" prop="password">
                  <div style="display: flex">
                      <el-input
                          class="input-width"
                          type="password"
                          placeholder="请输入新密码"
                          v-model="ruleForm.password"
                          autocomplete="new-password"
                          show-password
                      ></el-input>
                      <span style="font-size: 12px;margin-left: 10px;color: #999">密码必须包含数字、字母和特殊符号(!@#$%^&*)中至少两种,且长度不少于8位</span>
                  </div>
              </el-form-item>
              <el-form-item label="确认密码：" prop="passwordAgain">
                  <el-input
                  type="text"
                  class="input-width"
                  placeholder="请再次输入新密码"
                  v-model="ruleForm.passwordAgain"
                  autocomplete="new-password"
                  show-password></el-input>
              </el-form-item>
              <el-form-item class="btn_box">
                  <el-button :disabled="!btnDisabled" class="save" @click="save">确认修改</el-button>
                  <el-button class="back" @click="back">返回</el-button>
              </el-form-item>
          </el-form>
          <!-- 图片验证码对话框 -->
          <yzm_alert :yzmObj="yzmObj" v-on:setDwoncountSwitch="downcoutStart"></yzm_alert>
      </div>
  </div>
</template>

<script>
import yzm_alert from "@/components/yzm_alert/yzm_alert";
export default {
    components:{
        yzm_alert
    },
    data(){
        let validatePass = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入密码"));
            } else {
                let reg1 = /[a-zA-Z]/;
                let reg2 = /[0-9]/;
                if (!reg1.test(value)) {
                    callback(new Error("密码需为8位以上的数字和字母的组合"));
                    return;
                } else if (!reg2.test(value)) {
                    callback(new Error("密码需为8位以上的数字和字母的组合"));
                    return;
                } else if (value.length < 8) {
                    callback(new Error("密码需为8位以上的数字和字母的组合"));
                    return;
                } else {
                    callback();
                }
            }
        };
        let validatePass2 = (rule, value, callback) => {
            console.log(value);
            console.log(this.ruleForm.password);
            if (!value) {
                callback(new Error("请再次输入密码"));
            } else if (value !== this.ruleForm.password) {
                console.log("++++++++++++");
                callback(new Error("两次输入密码不一致!"));
            } else {
                callback();
            }
        };
        return{
            ruleForm:{
                mobile:'',
                mobileCode:'',
                password:'',
                passwordAgain:'',
                mobileMask:''
            },
            rules:{
                // mobile: [
                //     { required: true, trigger: "blur" }
                // ],
                mobileCode: [
                    { required: true, message: "请输入短信验证码", trigger: ['blur', 'change'] }
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: ['blur', 'change'] },
                    {pattern: /^(?![a-zA-z]+$)(?!\d+$)(?![!@#$%^&*]+$)[a-zA-Z\d!@#$%^&*]{8,}$/, message: '密码必须包含数字、字母和特殊符号(!@#$%^&*)中至少两种，且长度不少于8位'}
                ],
                passwordAgain: [
                    { required: true, validator: validatePass2, trigger: ['blur', 'change'] }
                ]
            },
            yzmObj: {
                mobile: "",
                dialogVisible: false,
                type: "MobileCodeTypeChangePassword"
            },
            downcount:false,
            sendCaptchaTime:60, // 倒计时
            captchaText:'获取验证码', // 验证码按钮
            getCodeInterval:null, // 验证码倒计时
            valids:{
                // mobile: false,
                mobileCode: false,
                password: false,
                passwordAgain: false
            }
        }
    },
    computed:{
        info(){
            return this.$store.state.info
        },
        btnDisabled(){
            let valids = this.valids;
            console.log(valids)
            if(valids.mobileCode && valids.password && valids.passwordAgain){
                return true;
            }
            return false;
        }
    },
    created(){
        console.log(this.$store.state.info)
        if (this.$store.state.info) {
            this.getParam();
        } else {
            this.needInfo("getParam");
        }
    },
    methods:{
        validate(prop, value, callback){
            this.valids[prop] = value;
            console.log(prop, value, callback)
        },
        /* 监测个人信息 */
        needInfo(fn) {
            let watchAch = this.$watch("info", (val, oldVal) => {
                if (val) {
                this[fn]();
                watchAch(); //取消监听
                }
            });
        },
        getParam(){
            let info = this.$store.state.info;
            let mobile = info.mobile;
            let mobileMask = `${info.mobile.substring(0,3)}****${info.mobile.substring(7)}`
            this.ruleForm = Object.assign({},this.ruleForm,{
                mobile,
                mobileMask
            })
        },
        // 打开验证码对话框
        getCode(){
            if(!this.downcount){
                if(this.ruleForm.mobile === null){
                    this.$message.info("请先绑定手机号");
                    return;
                }
                this.yzmObj.dialogVisible = true;
                this.yzmObj.mobile = this.info.mobile;
            }else{
                this.$message('请不要重复点击');
            }
        },
        // 发送验证码倒计时
        downcoutStart(data){
            if(data){
                clearInterval(this.getCodeInterval);
                this.downcount = true;
                this.sendCaptchaTime = 60;
                this.getCodeInterval = setInterval(() => {
                    this.sendCaptchaTime--;
                    this.captchaText = `${this.sendCaptchaTime}s`;
                    if (this.sendCaptchaTime === 0) {
                        this.captchaText = "获取验证码";
                        this.downcount = false;
                        clearInterval(this.getCodeInterval);
                    }
                },1000)
            }
        },
        // 保存
        save(){
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    this.updatePassword()
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        // 修改密码
        updatePassword() {
            let params = {
                mobile: this.ruleForm.mobile,
                mobileCode: this.ruleForm.mobileCode,
                password: this.common.encryptRSA(this.ruleForm.password)
            }
            this.api.modifyPassword(params, true).then(res => {
                if (res.error.err_code !== 0) return;
                this.$confirm("密码修改成功", "提示", {
                        confirmButtonText: "确定",
                        showCancelButton: false,
                        type: "success"
                    })
                    .then(() => {
                        this.common.getUserInfo();
                        this.ruleForm.mobileCode = '';
                        this.ruleForm.password = '';
                        this.ruleForm.passwordAgain = '';
                        this.captchaText = '获取验证码'
                });
            });
        },
        // 返回
        back(){
            this.$router.push({
                name:'personal_center_account_safe'
            })
        }
    }
}
</script>

<style lang="scss">
.change_password{
    height:545px;
    background:rgba(255,255,255,1);
    .content{
        .el-form{
            .el-form-item{
                .el-form-item__content{
                    .getCode{
                        margin-left: 10px;
                    }
                }
            }
            .input-width{
                width: 260px !important;
            }
            .btn_box{
                .save{
                    width: 90px;
                    height: 34px;
                    background-color: rgba(17,17,17,1);
                    color: $font-white;
                }
                .back{
                    width: 90px;
                    height: 34px;
                    background-color: $bg-white;
                    color: #333333;
                }
            }
        }
    }
}

</style>
